export var E2E_BACK_SUFFIX = '-back';
export var E2E_CLOSE_SUFFIX = '-close';
export var E2E_HEADER_SUFFIX = '-header';
export var HEADER_TEXT = {
  GO_BACK: 'Go back',
  CLOSE: 'Close'
};
export var HEADER_HEIGHT = 60;